import { API_ROUTES } from '@/constants/apiRoutes';
import { BankingInfoResponse } from '@/types/bankingInfo';
import { api } from '@/utils/api';

export const getBankingInfoService = async () => {
  const { data } = await api<BankingInfoResponse>({
    url: API_ROUTES.BANKING_INFO,
    method: 'get',
    version: 2,
  });

  return data;
};
